import axios from '../common/axios-auth';
import store from '../store/index.js';
export default class ServerProxy {
  serverRequest(data) {
    const authOptions = {
      method: data.method,
      url: data.url,
      mode: 'cors',
      headers: data.headers,
      json: true
    };
    if (data.body) {
      authOptions.data = data.body;
    }
    if(data.needMask){
      store.dispatch("setProcessingOverlay", true);
    }
    if(data.responseType){
      authOptions.responseType = data.responseType;
    }
    return new Promise(resolve => {
      axios(authOptions)
        .then(response => {
          console.log(response);
          if(response && response.data){
            const json = response.data;
            if(json && json.status && json.status.toUpperCase() == "SUCCESS"){
              if(data.callbackFunc && typeof data.callbackFunc === "function"){
                  data.callbackFunc();
              }
              //deal with getAccessTokeByAuthCode API put data in data attribute in response
              if(response.config.url.indexOf('getAccessTokeByAuthCode')!= -1){
                resolve(json.data)
              }else{
                resolve(json.content) //*change data to content when backend change is complete
              }

              //show result infomation dialog if status is success and request is configured to show result dialog
              if(data.needResultDialog){
                const infoObject = {};
                infoObject.showDlg = true;
                infoObject.buttons={
                    CloseButton:{
                        Caption:"Close"
                    }
                };
                infoObject.title="Information";
                infoObject.message=json.message;
                store.dispatch("setConfirmDialogDetails",infoObject);
              }
              
            }else{
               //do something when status is not success
               //deal with introspectToken API which doesn't have a status attribute in response
              if(response.config.url.indexOf('introspectToken') !=-1){
                resolve(json);
              }

              //dead with download API
              if(response.config.url.indexOf('communication/download') !=-1 && !json.status){
                resolve(json);
              }

              //show error infomation dialog if status is failed and request is configured to show result dialog
              if(data.needResultDialog){
                const errorObject = {};
                errorObject.showDlg = true;
                errorObject.buttons={
                    CloseButton:{
                        Caption:"Close"
                    }
                };
                errorObject.title="Error";
                errorObject.type="Error";
                errorObject.message=json.error;
                store.dispatch("setConfirmDialogDetails",errorObject);
              }
              
            }
          }

          //return null if any error
          resolve(null);
        })
        .catch(err => {
          if(data.failurecallbackFunc && typeof data.failurecallbackFunc === "function"){
            data.failurecallbackFunc();
          }
          resolve({
          error: err,
          });
        });
    });
  }
}